import ConfigService from "./ConfigService";
import HttpService from "./HttpService";




export default class TextRecognitionService 
{
  constructor(coreDomain) 
  {
    this.configService = new ConfigService();
    this.domain = coreDomain || this.configService.getTextRecognitionServiceHost();

  }


  imageTypeFromMimeType(mimeType)
  {
      var tokenize1 = mimeType.split("/");
      var tokenize2 = tokenize1[1].split(";");
      var result = tokenize2[0];
      return result;
  }

  async fetchTextRecognition(dataUri) 
  {
    //console.log("dataUri: ");
    //console.log(dataUri);
    var tokens = dataUri.split(",");
    var mimeType = tokens[0];
    var b64Payload = tokens[1];
    var imageType = this.imageTypeFromMimeType(mimeType);
    var data = {
        requests:
        [
            {
                image: {content: b64Payload},
                features: 
                [
                    {type: "TEXT_DETECTION",maxResults: 5}
                ]
            }
        ]
    };
    //var fullUrl =
    //  "https://vision.googleapis.com/v1/images:annotate?key=" +
    //  this.configService.getGoogleVisionApiKey();
    var path =  "/v1/images:annotate?key=" + this.configService.getGoogleVisionApiKey();
    var response = await HttpService.postJson(this.domain, path);
    return response;
}

 
 




}